'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var generateShimmerCss = require('./generateShimmerCss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Line = styled__default["default"].div.withConfig({
  componentId: "sc-2jxa96-0"
})(["height:24px;max-width:307px;width:100%;margin:16px;", ""], generateShimmerCss["default"]({
  start: 'calc(-1584px - 16px)',
  stop: 'calc(1584px - 16px)',
  size: '1584px'
}));
const Container = styled__default["default"].div.withConfig({
  componentId: "sc-2jxa96-1"
})(["box-sizing:border-box;border-color:#cccccc;width:100%;margin-top:32px;"]);
const LineItemSkeleton = () => /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(Line, null));

exports.LineItemSkeleton = LineItemSkeleton;
